import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "../lib/api";

export function useActiveClients() {
  const [clients, setClients] = useState([]);
  const [active, setActive] = useState(null);
  const [status, setStatus] = useState("loading"); // loading | done | error
  const [error, setError] = useState(null);
  const hasData = useRef(false);

  const load = useCallback(() => {
    setStatus("loading");
    setError(null);
    api.get("/clients")
      .then(({ data }) => {
        const act = data.filter((c) => !c.archived);
        hasData.current = true;
        setClients(act);
        setActive((prev) => (prev && act.some((c) => c.id === prev) ? prev : act[0]?.id ?? null));
        setStatus("done");
      })
      .catch((e) => {
        if (hasData.current) { setStatus("done"); return; } // keep previously loaded data
        const detail = e?.response
          ? `HTTP ${e.response.status}${e.response.data?.detail ? ` — ${e.response.data.detail}` : ""}`
          : e?.message || "Network error";
        setError(detail);
        setStatus("error");
      });
  }, []);

  useEffect(() => { load(); }, [load]);

  return { clients, active, setActive, status, error, retry: load };
}
